var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component"},[_c('v-textarea',{attrs:{"id":_vm.id,"counter":_vm.withCounter,"maxlength":_vm.max,"label":_vm.label,"placeholder":_vm.placeholder,"autocomplete":(new Date()).getTime()},on:{"input":_vm.onChange},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }